// src/pages/Dealer/ViewDealer.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import dealerService from '../../services/dealer.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const ViewDealer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dealer, setDealer]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast]     = useState(null);

useEffect(() => {
  const fetchDealer = async () => {
    try {
      const response = await dealerService.getDealerById(id);
      if (response.success) {
        // ✅ Unwrap nested data (same pattern as EditDealer.jsx)
        const dealerData = response.data?.data || response.data;
        console.log("Full Dealer API Response:", dealerData);
        setDealer(dealerData);
      }
    } catch (error) {
      setToast({ message: 'Failed to fetch dealer details', type: 'error' });
    } finally {
      setLoading(false);
    }
  };
  fetchDealer();
}, [id]);

  if (loading) {
    return (
      <div className="add-dealer-page">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>Loading dealer details...</p>
        </div>
      </div>
    );
  }

  if (!dealer) {
    return (
      <div className="add-dealer-page">
        <p>Dealer not found.</p>
        <button className="btn btn-secondary" onClick={() => navigate('/dealer/view')}>
          Back to Dealers
        </button>
      </div>
    );
  }

  // Safer date formatter — returns null for missing/invalid dates so DetailRow shows "—"
  const formatDate = (val) => {
    if (!val) return null;
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d.toLocaleDateString('en-IN');
  };

  const DetailRow = ({ label, value }) => (
    <div className="form-group">
      <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>{label}</label>
      <div
        className="form-input"
        style={{
          background: '#f8f9fa',
          color: '#333',
          cursor: 'default',
          minHeight: '42px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {value || <span style={{ color: '#aaa' }}>—</span>}
      </div>
    </div>
  );

  return (
    <div className="add-dealer-page">
      {toast && (
        <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />
      )}

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/dealer/view">Dealers</a></li>
          <li className="breadcrumb-item active">View Dealer</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Dealer Details</h4>
        <button className="btn btn-primary" onClick={() => navigate(`/dealer/edit/${id}`)}>
          ✏️ Edit Dealer
        </button>
      </div>

      <div className="form-card">

        {dealer.photo && (
          <div style={{ marginBottom: 20 }}>
            <img
              src={dealer.photo}
              alt="Dealer"
              style={{ width: 100, height: 100, borderRadius: 8, objectFit: 'cover', border: '1px solid #e0e0e0' }}
            />
          </div>
        )}

        {/* Basic Info */}
        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Shop Name"     value={dealer.dealerShopName} />
            <DetailRow label="Owner Name"    value={dealer.ownerName} />
            <DetailRow label="Date of Birth" value={formatDate(dealer.dateOfBirth)} />
          </div>
        </div>

        {/* ✅ Area Assignment */}
<div className="form-section">
  <div className="form-row">
    <DetailRow label="Region"           value={dealer.region?.name} />
    <DetailRow label="Headquarter"      value={dealer.headquarter?.name} />
    <DetailRow label="Sub-Headquarter" value={dealer.subHeadquarter?.name || "—"} />
  </div>
  <div className="form-row">
    <DetailRow label="Company" value={dealer.company?.name} />
  </div>
</div>

        {/* Tax & Identity */}
        <div className="form-section">
          <div className="form-row">
            <DetailRow label="GST Number"    value={dealer.gstNumber} />
            <DetailRow label="PAN Number"    value={dealer.panNumber} />
            <DetailRow label="Aadhar Number" value={dealer.aadharCardNumber} />
          </div>
        </div>

        {/* Address */}
        <div className="form-section">
          <div className="form-row">
            <div className="form-group form-group-full">
              <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>Address</label>
              <div
                className="form-input"
                style={{ background: '#f8f9fa', color: '#333', cursor: 'default', minHeight: '60px', alignItems: 'flex-start', padding: '10px 12px' }}
              >
                {dealer.address || <span style={{ color: '#aaa' }}>—</span>}
              </div>
            </div>
          </div>
          <div className="form-row">
            <DetailRow label="State"    value={dealer.state} />
            <DetailRow label="District" value={dealer.district} />
            <DetailRow label="Tahsil"   value={dealer.tahsil} />
          </div>
        </div>

        {/* Contact */}
        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Mobile" value={dealer.mobile} />
            <DetailRow label="Email"  value={dealer.email} />
          </div>
        </div>

        {/* Location */}
        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Latitude"  value={dealer.latitude} />
            <DetailRow label="Longitude" value={dealer.longitude} />
            <DetailRow label="Remark"    value={dealer.remark} />
          </div>
        </div>

        {dealer.latitude && dealer.longitude && (
          <div style={{ marginTop: 16 }}>
            <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>Location Map</label>
            <div style={{ borderRadius: 8, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
              <iframe
                title="Dealer Location"
                width="100%"
                height="220"
                style={{ border: 'none', display: 'block' }}
                src={`https://maps.google.com/maps?q=${dealer.latitude},${dealer.longitude}&z=14&output=embed`}
              />
            </div>
          </div>
        )}

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/dealer/view')}>
            ← Back to List
          </button>
          <button className="btn btn-primary" onClick={() => navigate(`/dealer/edit/${id}`)}>
            ✏️ Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewDealer;